import { useState } from 'react';
import '../../styles.scss';
import { ButtonGroup, Dropdown, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useProjectContext } from '~/hooks';
import AcceptProjectBidModal from '../modals/AcceptProjectBid';
import DeclineProjectBidModal from '../modals/DeclineProjectBid';
import { ProjectBid, ProjectBidSummary } from '~/types/project';
import ActionsButton from './ActionsButton';
import ActionsDropdownMenu from './ActionsDropdownMenu';

interface ActionsProps {
  data: ProjectBidSummary;
  awaitingBid: boolean;
}

const Actions = ({
  data,
  awaitingBid,
}: ActionsProps) => {
  const { project, fetchProject } = useProjectContext();
  const [modalType, setModalType] = useState<null | 'ACCEPT_BID' | 'DECLINE_BID'>(null);
  const closeModal = () => setModalType(null);

  return (
    !project?.portfolioId ? (
      <>
        <div className='actions-container'>
          <ButtonGroup primary compact>
            <ActionsButton
              investorId={data?.investor?.id}
              awaitingBid={awaitingBid}
              setModalType={setModalType}
            />
            <Dropdown
              className='button icon'
              trigger={<></>}
            >
              <Dropdown.Menu className='actions-dropdown-menu' >
                <ActionsDropdownMenu
                  investorId={data?.investor?.id}
                  awaitingBid={awaitingBid}
                  setModalType={setModalType}
                />
              </Dropdown.Menu>
            </Dropdown>
          </ButtonGroup>
        </div>

        {modalType === 'ACCEPT_BID' && (
          <AcceptProjectBidModal
            project={project}
            bid={data?.bid as ProjectBid}
            fetchProject={fetchProject}
            closeModal={closeModal}
          />
        )}
        {modalType === 'DECLINE_BID' && (
          <DeclineProjectBidModal
            projectId={data?.childProjectId}
            fetchProject={fetchProject}
            closeModal={closeModal}
          />
        )}
      </>
    ) : (
      <div className='actions-container'>
        <Button size="small" as={Link} to={`/portfolio/${project?.portfolioId}/bidding`} primary>
          Go to portfolio bidding
        </Button>
      </div>
    )
  );
};

export default Actions;